import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { useFieldArray, Controller } from 'react-hook-form';
import { FaPlus, FaTimes } from 'react-icons/fa';
import FormInput from '../form/FormInput';
import { getNestedError } from '../../utils/roleHelpers';

const StepAuditionLocations = ({ control, errors, handlePincodeLookup }) => {
    const { fields, append, remove } = useFieldArray({ control, name: "auditionLocations" });

    return (
        <div className="animate-fade-in">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="form-section-title mb-0 border-0">Venue Addresses</div>
                <Button variant="outline-danger" size="sm" className="fw-bold d-inline-flex align-items-center gap-2" onClick={() => append({ pincode: '', address1: '', address2: '', state: '', district: '' })}>
                    <FaPlus className="me-1" /> Add Location
                </Button>
            </div>

            {fields.map((item, index) => (
                <div key={item.id} className="location-item-wrapper mb-4">
                    <div className="d-flex justify-content-between mb-3">
                        <span className="badge bg-danger">Location #{index + 1}</span>
                        {fields.length > 1 && <Button variant="link" className="text-danger p-0" onClick={() => remove(index)}><FaTimes size={18}/></Button>}
                    </div>
                    
                    <Row> 
                        <Col md={3}>
                            <FormInput name={`auditionLocations.${index}.address1`} label="Audition Location *" control={control} errors={errors} isRequired /> 
                            <Controller name={`auditionLocations.${index}.address2`} control={control} render={({ field }) => (<input type="hidden" {...field} value={field.value ?? ""} />)} />
                        </Col>
                         <Col md={3}><FormInput name={`auditionLocations.${index}.state`} label="State" control={control} errors={errors} isRequired /> </Col>
                         <Col md={3}><FormInput name={`auditionLocations.${index}.district`} label="District" control={control} errors={errors} isRequired /></Col>
                        
                         <Col md={3}><Form.Group className="mb-4">
                            <Form.Label className="form-label">Pin Code</Form.Label>
                            <Controller name={`auditionLocations.${index}.pincode`} control={control} render={({ field }) => (
                                <Form.Control 
                                    {...field} 
                                    value={field.value ?? ""}
                                    maxLength={6} 
                                    placeholder="6-digit Pincode" 
                                    className="custom-form-input shadow-none" 
                                    isInvalid={!!getNestedError(errors, `auditionLocations.${index}.pincode`)}
                                    onChange={(e) => { 
                                        field.onChange(e); 
                                        if (e.target.value.length === 6) handlePincodeLookup(e.target.value, index); 
                                    }} 
                                />
                            )} />
                            {getNestedError(errors, `auditionLocations.${index}.pincode`) && <Form.Control.Feedback type="invalid">{getNestedError(errors, `auditionLocations.${index}.pincode`)?.message}</Form.Control.Feedback>}
                        </Form.Group></Col>
                    </Row>
                </div>
            ))}
        </div>
    );
};

export default StepAuditionLocations;